import { DonutChart } from '@bitcine/cinesend-theme/dist'
import DataCard from './data_card'
import { useQuery } from '@tanstack/react-query'

const ProgressCard = ({ cycleID }) => {
  const { data: percentage, isLoading, error } = useQuery([`cycles/`, cycleID, `/get-progress`])

  return (
    <DataCard title='Progress' pending={isLoading} error={error}>
      <div className='flex flex-row justify-between'>
        {percentage?.data.map((item, index) => (
          <div className='px-6' key={index}>
            <div className='flex align-middle items-center relative  '>
              <DonutChart
                data={[
                  { name: item.name, value: item.percentage, color: '#009b3a' },
                  { name: '', value: 100 - item.percentage, color: '#bcbcbc' },
                ]}
                size={{
                  hoverRadiusIncrease: 3,
                  width: 200,
                  height: 200,
                  outerRadius: 80,
                  innerRadius: 70,
                }}
                hideLegend={true}
                className={``}
                tooltip={false}
              />
              <div className='absolute w-full text-center'>{item.percentage}%</div>
            </div>
            <p className='text-center'>{item.name}</p>
          </div>
        ))}
      </div>
    </DataCard>
  )
}

export default ProgressCard
